import { reloadAfterChunkError } from './refresh-cache'

export function installPreloadErrorRecovery() {
  window.addEventListener('vite:preloadError', event => {
    event.preventDefault()
    reloadAfterChunkError()
  })
}
